function throttle(fn, delay) {
    let canCall = true;
    return (...args)=>{
        if (canCall) {
            // eslint-disable-next-line prefer-spread
            fn.apply(null, args);
            canCall = false;
            setTimeout(()=>{
                canCall = true;
            }, delay);
        }
    };
}

export { throttle };
//# sourceMappingURL=throttle.js.map
